import React from "react";
import { createRoot } from 'react-dom/client';
import * as ReactDOM from "react-dom";
import MainPresenter from "./components/app/presentation/mainPresenter";



const disableReactDevTools = (): void => {
    const noop = (): void => undefined;
    const DEV_TOOLS = (window as any).__REACT_DEVTOOLS_GLOBAL_HOOK__;

    if (typeof DEV_TOOLS === 'object') {
        for (const [key, value] of Object.entries(DEV_TOOLS)) {
            DEV_TOOLS[key] = typeof value === 'function' ? noop : null;
        }
    }
};

disableReactDevTools();


const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<MainPresenter/>);